import axios from "axios";

const API_BASE = "https://rmrthemeaonlineorderingwebapi.azurewebsites.net/api";

const client = axios.create({
  baseURL: API_BASE,
});

const meaMenuApi = {
  getOnlineMenu: () => client.get("/MeaMenu/online"),
};

export default meaMenuApi;